/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SystemPanelFrameComponent } from './system-panel-frame.component';
import { RootPathSelectorModule } from '../root-path-selector';
import { SelectSystemModule } from '../select-system';
import { CategoryScopeModule } from '../category-scope';
import { SysqueAlertModule } from '../../../../../../shared/ui/src/lib/components/sysque-alert';
import { SysqueContextMenuModule } from '../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { PanelSystemModule } from '../system-options/panel-system';
import { CableTraySystemModule } from '../system-options/cable-tray-system';
import { DxButtonModule, DxContextMenuModule, DxProgressBarModule } from 'devextreme-angular';
import { SysqueProgressBarModule } from '../../../../../../shared/ui/src/lib/components/sysque-progress-bar';
import { AlertModule } from '../../../../../../shared/ui/src/lib/components/alert';
import { SystemOperationsModule } from '../system-operations';

@NgModule({
  declarations: [SystemPanelFrameComponent],
  imports: [
    CommonModule,
    FormsModule,
    RootPathSelectorModule,
    SelectSystemModule,
    CategoryScopeModule,
    SysqueAlertModule,
    SysqueContextMenuModule,
    PanelSystemModule,
    CableTraySystemModule,
    DxButtonModule,
    DxProgressBarModule,
    DxContextMenuModule,
    SysqueProgressBarModule,
    AlertModule,
    SystemOperationsModule
  ],
  exports: [SystemPanelFrameComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SystemPanelFrameModule {}
